import { DynamicLoad } from '@/_cactus_core/build/dynamicLoad';





import ab7e862876922f2089933540aeeb865c3b from "./generated-01d798ab-7f00-41d1-8810-f4f8b0ff58b3.json";

import a57295aaf776bd27bbe6a8c14a8e0a513b from "./generated-b14f83c2-d49d-46c3-92af-4cf2fb5b9338.json";

import a83ab003c0739e9c5a75264453e649319b from "./generated-0345d723-d547-4013-b54d-15a2fc8e116e.json";

import ae6a4e0e8587b752048f50a18dc625046b from "./generated-d95fc8e4-590f-46c2-9547-8dc79963dc27.json";

import ad1bd017c4acf04cb53d2745d9443b46db from "./generated-41191bfa-f87b-4256-85ca-7638b79d692b.json";

import a5842f87172acc15aee0b8323e4b2c9dcb from "./generated-ee39145e-2467-4201-91af-e6d2d5d7f07d.json";

import ac265c26a5aeea8e290d800701216556bb from "./generated-833643ed-057c-4251-928a-90994e7307f7.json";

import a904e09e9e8d7a9c29c05a9314e5030ebb from "./generated-4ab3b9fd-080c-4bb4-bb98-dc98d4849490.json";

import aefb7228182370637c52cb4d2f71abecfb from "./generated-d7262a01-d5be-4ce5-b23a-a5d401b10355.json";

import a0d72f52d0763c3fb75ceefc2bb35e742b from "./generated-6995c6ef-2eb1-4ed4-bccb-326e806c76fa.json";

import a5f842a6e3f444fea0ab855e35fc5b805b from "./generated-c72f2c21-d502-4a50-8f0d-f7b475e614ba.json";

import a94cab98b9a87340996ece492cc6b1fc1b from "./generated-7f6e60c8-4445-4249-bfc2-cc14321ca8b2.json";

import a3ffb20e0fb463209fbb99a27627aed5eb from "./generated-752f43a5-1f5c-4e5e-b7a6-6676744af4ab.json";

import a2ead5192114bff6bd685bb8780bf527ab from "./generated-31f2b60f-d5cf-4450-8d72-29e77cf96ab1.json";

import ad8acb711953e5e1a817170a45f4dbfa3b from "./generated-3ad7c5bb-ab24-4b38-9324-ae95f1bf73cc.json";

import ae66525400c09e2f87392de6b373bc742b from "./generated-3262aea3-3a39-40d1-a3f5-d73e40948f69.json";

import a38028298c3910b86a7a5a015b2edb72bb from "./generated-5aecc924-b410-4532-922b-2a59a8d29ddc.json";





/* eslint-disable */

export default async function(url) {
  let storeData = false;

  async function direct(jsonResult) {
    return new Promise(async function(done,err) {
      try {
        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };
        
        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }

  async function ok(cachedJson) {
    return new Promise(async function(done,err) {
      try {
        const jsonResult = await DynamicLoad(cachedJson);

        storeData = {
          headers: jsonResult.headers,
          data: jsonResult.data,
        };

        done(storeData);
      } catch(e) {
        err(e);
      }
    });
  }
  
  try {
  
  




         if(url === "/api/appearance"){
            
                    await direct(ab7e862876922f2089933540aeeb865c3b);
                
        }
    


        else if(url === "/api/getlegalterm"){
            
                    await direct(a57295aaf776bd27bbe6a8c14a8e0a513b);
                
        }
    


        else if(url === "/api/country"){
            
                    await direct(a83ab003c0739e9c5a75264453e649319b);
                
        }
    


        else if(url === "/api/crypto/all"){
            
                    await direct(ae6a4e0e8587b752048f50a18dc625046b);
                
        }
    


        else if(url === "/api/bff/features"){
            
                    await direct(ad1bd017c4acf04cb53d2745d9443b46db);
                
        }
    


        else if(url === "/api/payment-providers"){
            
                    await direct(a5842f87172acc15aee0b8323e4b2c9dcb);
                
        }
    


        else if(url === "/api/bff/games/top-wins"){
            
                    await direct(ac265c26a5aeea8e290d800701216556bb);
                
        }
    


        else if(url === "/api/bff/games/last-wins"){
            
                    await direct(a904e09e9e8d7a9c29c05a9314e5030ebb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-da-pg&per_page=15"){
            
                    await direct(aefb7228182370637c52cb4d2f71abecfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=roleta&per_page=16"){
            
                    await direct(a0d72f52d0763c3fb75ceefc2bb35e742b);
                
        }
    


        else if(url === "/api/undefined&per_page=undefined"){
            
                    await direct(a5f842a6e3f444fea0ab855e35fc5b805b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-crash&per_page=15"){
            
                    await direct(a94cab98b9a87340996ece492cc6b1fc1b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-de-aventura&per_page=15"){
            
                    await direct(aefb7228182370637c52cb4d2f71abecfb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=cassino-ao-vivo&per_page=15"){
            
                    await direct(a3ffb20e0fb463209fbb99a27627aed5eb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=slots&per_page=15"){
            
                    await direct(a2ead5192114bff6bd685bb8780bf527ab);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=jogos-novos&per_page=15"){
            
                    await direct(aefb7228182370637c52cb4d2f71abecfb);
                
        }
    


        else if(url === "/api/casino-games/filter?per_page=1&per_page=15"){
            
                    await direct(ad8acb711953e5e1a817170a45f4dbfa3b);
                
        }
    


        else if(url === "/api/casino-games/filter?providers[]=hacksaw&per_page=15"){
            
                    await direct(ae66525400c09e2f87392de6b373bc742b);
                
        }
    


        else if(url === "/api/casino-games/filter?categories[]=blackjack&per_page=15"){
            
                    await direct(a38028298c3910b86a7a5a015b2edb72bb);
                
        }
    


        else if(url === "/api/casino-games/filter?categories%5B%5D=all"){
            
                    await direct(ad8acb711953e5e1a817170a45f4dbfa3b);
                
        }
    





  } catch(ex){
    console.log('failed to get cache',ex,url);
  }

  return storeData;
};

/* eslint-enable */